export const CREDIT_TYPES = {
  AVAILABLE: 'available',
  HOLD_FOR_FUTURE: 'hold_for_future',
  IN_FLIGHT: 'in_flight',
  UNASSIGNED: 'unassigned',
} as const;

export type CreditType = (typeof CREDIT_TYPES)[keyof typeof CREDIT_TYPES];
